import "../../../src/App.css";
import Status from "../../components/Status/Status";
import AddStatus from "../../components/AddStatus/AddStatus";
import Navbar from "../../components/Navbar/navbar";
import Sidebar from "../../components/Sidebar/Sidebar";
import StatusList from "../../components/StatusList/StatusList";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import PaginationLink from "../../components/Pagination/Pagination";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

function StatusMaster() {
  const [statusDetailResponse, setStatusDetailResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [selectedStatusId, setSelectedStatusId] = useState();
  const [filterCityData, setFilterCityData] = useState(false);
  const title = "Add Status";
  const heading = "Status List";
  const baseAPI = process.env.REACT_APP_API_URL;

  function tokenStorage(){
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETStatus?ID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          //console.log(response.data.data);
          setStatusDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };
  useEffect(() => {
    tokenStorage();
  }, []);

  const GetId = (param) => {
    setSelectedStatusId(param);

  };

  //console.log(statusDetailResponse);

  return (
    <>
    <div className="d-flex flex-row app">
      <MiniDrawer />
      <div
        className="container-fluid"
        style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
      >
        <div
          className="d-flex flex-column w-100"
          style={{ backgroundColor: "#F4F4F4" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
            <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                 Status Master| <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px" }}>&gt; Master</span>
              </h1>
            </div>
            <div style={{ width: "8rem" }}>
              <select className="form-control" name="country">
                <option value="0">INDIA </option>
                <option value="1">DUBAI </option>
              </select>
            </div>
          </div>
          <div>
            <Wrapper className="ViewLeadDetails">
            <MasterTopButtons
            title={title}
            heading={heading}
            setOpenAddProfile={setOpenAddProfile}
            openAddProfile={openAddProfile}
            setOpenProfile = {setOpenProfile}
            setFilterCityData = {setFilterCityData}
            filterCityData = {filterCityData}
          />
          {openAddProfile ? <AddStatus tokenStorage = {tokenStorage} openAddProfile = {openAddProfile} setOpenAddProfile = {setOpenAddProfile} /> : null}
          {openProfile ? <Status tokenStorage = {tokenStorage} openProfile = {openProfile} setOpenProfile = {setOpenProfile} selectedStatusId={selectedStatusId} /> : null}
          <StatusList
            statusDetailResponse={statusDetailResponse}
            setOpenProfile={setOpenProfile}
            openProfile={openProfile}
            GetId={(param) => GetId(param)}
            openAddProfile = {openAddProfile} 
            setOpenAddProfile = {setOpenAddProfile}
          />
              <PaginationLink />
            </Wrapper>
          </div>
        </div>
      </div>
    </div>
  </>
  );
}

export default StatusMaster;
